import '@hotwired/turbo-rails'

import { application } from './controllers/application'

import BookingPageController from './controllers/booking_page_controller'
import FormController from './controllers/form_controller'
import StaticSearchController from './controllers/static_search_controller'

application.register('booking-page', BookingPageController)
application.register('form', FormController)
application.register('static-search', StaticSearchController)
